exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._19Ydzguf7Kx7INdSPCGaCo{height:1.06667em;width:1.06667em;display:inline-block;position:relative}._19Ydzguf7Kx7INdSPCGaCo svg{left:0;bottom:-0.15em;position:absolute;width:100%;height:100%;fill:currentColor;stroke:currentColor}._19Ydzguf7Kx7INdSPCGaCo._11v-zNk9OS-gJUJJNc3CjN{height:1em;width:1em;vertical-align:middle}._19Ydzguf7Kx7INdSPCGaCo._11v-zNk9OS-gJUJJNc3CjN svg{bottom:0}\n", ""]);

// Exports
exports.locals = {
	"Icon": "_19Ydzguf7Kx7INdSPCGaCo",
	"hasSize": "_11v-zNk9OS-gJUJJNc3CjN"
};